var cache = {}, num = 0;
var DATA_WIDGET_CID = 'data-widget-cid';
var $ = require('@alife/alpha-jquery/jquery');
/**
 * @module alpha-widget/registry
 * @static
 */
var registry = {
    length : 0,
    /**
     * 添加widget到全局的缓存中心
     * @param widget {Widget}
     */
    add : function(widget) {
        var id = widget.cid || uniqueId();
        cache[id] = widget;
        this.length++;
    },
    /**
     * 根据widget从缓存中移除Widget
     * @param widget {String}
     */
    remove : function(widget) {
        if(widget) {
            var id = widget.cid;
            delete cache[id];
            this.length--;
        }
    },
    /**
     * 根据id找到对应的widget
     * @param id {String}
     */
    byId : function(id) {
        return cache[id];
    },
    /**
     * 根据DOM节点找到对应的widget
     * @param node {HTMLElement}
     * @returns {Widget}
     */
    byNode : function(node) {
        return cache[node.getAttribute('data-widget-cid')];
    },
    /**
     * 在指定的节点下面寻找widget, 仅包含直系子级
     * @param root
     * @param skipNode
     * @returns {Array}
     */
    findWidgets : function(root, skipNode) {
        var result = [],
            getChildWidgets = function(container) {
                for(var node = container.firstChild; node; node = node.nextSibling){
                    if(node.nodeType == 1) {
                        var widget = registry.byNode(node);
                        if(widget) {
                            result.push(widget);
                        }
                        else if(node !== skipNode) {
                            getChildWidgets(node);
                        }
                    }
                }
            };
        getChildWidgets(root);
        return result;
    },
    /**
     * 在指定的节点下面寻找widget。
     * @param root {jQuery selector}
     * @param selector {jQuery selector}
     * @param skipNode {jQuery selector}
     * @returns {Array}
     */
    find : function(root, selector, skipNode) {
        if(!root || !selector) {
            return [];
        }
        var result = [], byNode = this.byNode;
        var widgetEls = $(root).find('['+ DATA_WIDGET_CID +']').filter(selector);
        if(skipNode) {
            widgetEls = widgetEls.not($(skipNode).find('*['+ DATA_WIDGET_CID +']').andSelf());   
        }
        widgetEls.each(function(index, el){
            var widget = byNode(el);
            if(widget) {
                result.push(widget);
            }
        });
        return result;
    },
    
    /**
     * 根据DOM寻找最近的父级widget
     * @param node {HTMLElement}
     * @returns {Widget}
     */
    getClosestWidget : function(node) {
        var id;
        while(node) {
            id = node.nodeType == 1 && node.getAttribute('data-widget-cid');
            if(id) {
                return cache[id];
            }
            node = node.parentNode;
        }
        return null;
    }
};
function uniqueId() {
    return '__widget' + num++;
}
module.exports = registry;